import React, { FC } from 'react';
import usePageBreadcrumbs from '../../hooks/usePageBreadcrumbs';
import { ReactComponent as IconHouseSimple } from '../../icons/house-simple.svg';
import * as StyledBreadcrumbs from './breadcrumbs.styles';

interface Props {
	pageId: number;
}

const Breadcrumbs: FC<Props> = ({ pageId }) => {
	const breadcrumbs = usePageBreadcrumbs(pageId);

	return (
		<StyledBreadcrumbs.Wrapper>
			<StyledBreadcrumbs.IconWrapper>
				<IconHouseSimple />
			</StyledBreadcrumbs.IconWrapper>
			{breadcrumbs &&
				breadcrumbs.map((item, index) => (
					<StyledBreadcrumbs.Breadcrumb key={item.Id}>
						<StyledBreadcrumbs.BreadcrumbLink to={item.Url}>
							{item.Name.substring(0, 35)}
							{item.Name.length > 35 && <span>...</span>}
						</StyledBreadcrumbs.BreadcrumbLink>
						{index < breadcrumbs.length - 1 && (
							<StyledBreadcrumbs.BreadcrumbSep>/</StyledBreadcrumbs.BreadcrumbSep>
						)}
					</StyledBreadcrumbs.Breadcrumb>
				))}
		</StyledBreadcrumbs.Wrapper>
	);
};

export default Breadcrumbs;
